module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/grapesjs/dist/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = ../../../../grapesjs/dist/fonts/fontawesome-webfont.ttf?v=4.7.0
// module chunks = 2